import React, { useState, useEffect } from 'react'
import { Modal, Button, Table } from 'react-bootstrap'
import _, { isNumber } from 'lodash'

function ListHighTurnover(props) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

 const {data, evasion} = props
  return (
    <>
       <a className="link" onClick={handleShow} >
        {evasion && isNumber(evasion *1) && evasion != Infinity && evasion <= 100 ? evasion : 0}%
      </a>
        <Modal size='lg' show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Risco de evasão Medio Alto</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Table responsive bordered style={{ width: 100 + "%" }}>
              <thead>
                <tr>
                  <th className="name-header">Nome</th>
                  <th className="name-header">Área</th>
                </tr>
              </thead>
              <tbody>

                {_.map(data, (user, id) => (
                  <>
                      <tr key={id}>
                       <td>{user.name}</td>
                       <td>{user.areaName}</td>
                      </tr>
                  </>
                ))}

              </tbody>
            </Table>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Fechar
          </Button>
          </Modal.Footer>
        </Modal>
    </>
  );
}

export default ListHighTurnover
